// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"4e53d924","147":"8e8595b7","235":"a0f59611","357":"46850955","843":"efa05dc8","907":"efa05dc8"}[chunkId] + ".chunk.css";
};